import { render, staticRenderFns } from "./DkoToolbarMenu.vue?vue&type=template&id=ba7f8b92&scoped=true"
import script from "./DkoToolbarMenu.vue?vue&type=script&lang=js"
export * from "./DkoToolbarMenu.vue?vue&type=script&lang=js"
import style0 from "./DkoToolbarMenu.vue?vue&type=style&index=0&id=ba7f8b92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7f8b92",
  null
  
)

export default component.exports